module.exports = __webpack_public_path__ + "img/hook_KONDOTEC_2.67273734.png";